import { posthogEvents } from '@/shared/constants/constants';
import { posthogLog } from '@/shared/pinia/modules/posthog/logger';
import type { SearchSurface } from '@/shared/tracking/search-used';
import type { RelewiseFailureReason } from '@/shared/utils/relewise-fallback-reason';

type TrackSearchFallbackInput = {
  reason: RelewiseFailureReason;
  surface: SearchSurface;
  durationMs: number | null;
  cooldown: boolean;
};

const trackedSurfaces = new Set<SearchSurface>();

export const trackSearchFallback = ({
  reason,
  surface,
  durationMs,
  cooldown
}: TrackSearchFallbackInput) => {
  if (trackedSurfaces.has(surface)) {
    return;
  }
  trackedSurfaces.add(surface);

  const data = {
    reason,
    surface,
    duration_ms: durationMs,
    cooldown
  };

  posthogLog('search_fallback', data);
  window.posthog?.capture(posthogEvents.SEARCH_FALLBACK, data);
};

/** Test-only: allow each surface to fire again so each spec starts clean. */
export const __resetSearchFallbackTrackingForTests = () => {
  trackedSurfaces.clear();
};
